import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { SyncOperation } from '../../offline/sync-operation.model';

export type NewSyncOperation = Omit<
  SyncOperation,
  'id' | 'createdAt' | 'attempts' | 'nextAttemptAt' | 'status' | 'idempotencyKey'
> & {
  idempotencyKey?: string;
};

export const SyncQueueActions = createActionGroup({
  source: 'Sync Queue',
  events: {
    'Enqueue Requested': props<{ operation: NewSyncOperation }>(),
    'Enqueue Succeeded': props<{ operation: SyncOperation }>(),
    'Enqueue Failed': props<{ error: string }>(),
    'Drain Requested': emptyProps(),
    'Drain Completed': emptyProps(),
    'Drain Failed': props<{ error: string }>(),
  },
});
